import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "work-the-leads-queue",
  courseId: "investigations",
  order: 3,
  title: "Leads queue",
  subtitle: "Work the flagged leads",
  summary:
    "Leads are timestamped flags from every call and document, ranked by severity. Confirm, dismiss, or add a note to each one. Nothing is ever deleted.",
  learn: [
    "Filter leads by status and severity",
    "Jump to the exact second or page a lead came from",
    "Confirm or dismiss without losing the record",
  ],
  minutes: 4,
  releasedAt: "2026-08-24T00:00:00.000Z",
  gate: "investigations",
  body: [
    {
      type: "paragraph",
      text: "The Leads tab is the queue you work after each batch. Each lead has a category, a severity, a quote, and an anchor: a timestamp in a call, a page in a document, a row in a spreadsheet, a region of a photo, or a second in a video.",
    },
    {
      type: "steps",
      items: [
        "Open the Leads tab.",
        "Filter by New, Confirmed, Dismissed, Open, or All, and set \"Severity ≥\" to focus on what matters.",
        "Click a lead to open its source at the anchor. A call plays from that second with the transcript line highlighted. A document opens on the page with the quote boxed.",
        "Confirm a lead that holds up, or dismiss one that does not. Add a note either way.",
      ],
    },
    {
      type: "paragraph",
      text: "Leads from your own case documents (reports, official records) appear in a separate section, \"From your case documents\", below the evidence queue.",
    },
    {
      type: "callout",
      tone: "note",
      title: "Dismiss is a status, not a delete",
      text: "Dismissed leads stay in the record and in the discovery export. That is deliberate: Brady obligations mean the defense can see what the AI flagged and what you set aside.",
    },
    {
      type: "callout",
      tone: "tip",
      title: "Official documents",
      text: "They are never mined for threat flags. They produce only discrepancy and report-note leads, where the document disagrees with what the calls say.",
    },
    {
      type: "paragraph",
      text: "The Brief shows how your confirmations feed the cross-call summary.",
    },
  ],
  related: ["read-the-brief", "calls-and-transcripts", "export-and-discovery"],
};

export default lesson;
